import styled from 'styled-components';

const StyledDiv = styled.div`
    align-items: center;
    display: flex;
    height: 40px;
    justify-content: center;
`;

export default { StyledDiv };
